import { useState } from "react";
import useFormData from "hooks/useFormData";
import AuthAPI from "api/AuthAPI";

import Button from "components/buttons/Button";
import Loader from "components/general/Loader";
import FormInput from "components/form/FormInput";
import useSendRequest from "hooks/useSendRequest";

const inputs = [
   { name: "current_password", label: "Obecne hasło" },
   { name: "new_password", label: "Nowe hasło" },
   { name: "new_password_confirmation", label: "Powtórz nowe hasło" }
]

export default function ChangePassword({ show_form, setShowForm }: {
   show_form: boolean;
   setShowForm: ( s: boolean ) => void;
}) {

   const { data, errors, setErrors, onDataChange } = useFormData();
   const { querying, sendRequest } = useSendRequest({
      APIMethod: AuthAPI.changePassword,
      success_message: "Hasło zostało pomyślnie zmienione!",
      onSuccess: () => setShowForm( false ),
      setErrors
   });

   const onSubmit = async( e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      await sendRequest({
         current_password: data.current_password as string,
         new_password: data.new_password as string,
         new_password_confirmation: data.new_password_confirmation as string
      });
   }

   return (
      <>
         { show_form && 
            <>
               <h2> Zmień hasło </h2>

               <p> Aby dokonać zmiany, podaj swoje obecne hasło, a następnie dwa razy wpisz nowe hasło. </p>

               <form onSubmit={ onSubmit }> 
                  { inputs.map(({ name, label }) => {

                     return (
                        <FormInput
                           key={ name }
                           name={ name }
                           value={ String( data[ name ] || "" )}
                           error={ errors[ name ]}
                           type="password"
                           label={ label }
                           onChange={ onDataChange }
                        />
                     )
                  })}

                  { !querying && 
                     <div>
                        <Button
                           extra_classes="red transparent"
                           onClick={() => setShowForm( false )}
                        > 
                           Anuluj 
                        </Button>
                        
                        <Button type="submit"> Zapisz zmiany </Button>
                     </div>
                  }

                  { querying && <Loader/> }
               </form>
            </>
         }

         { !show_form &&
            <div> 
               <Button onClick={() => setShowForm( true )}> 
                  Zmień hasło 
               </Button>
            </div>
         }
      </>
   )
}